export const trackClick = (trackingUrl: string) => {
  fetch(trackingUrl, {
    method: "HEAD",
    redirect: "error", // More strict than 'manual' - will error on redirect attempts
    keepalive: true,
  }).catch((err) => {
    console.debug("Track click failed:", err);
  });
};
